import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging,
    Selection,
    Scrolling,
    Export
} from 'devextreme-react/data-grid';
import Request from "../../../components/api/Request";
import CustomStore from 'devextreme/data/custom_store';     
import * as AppActions from '../../../actions/AppActions'; 
import { Popup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';   
import { ToastType } from "../../../constants/Constants";
import { showToast, parseDate,hasRole } from "../../../utils/Utils";
import './TesvikKanunu.scss';  
import TesvikKanunuDetail from './TesvikKanunuDetail';

const TesvikKanunu = (props) => {

    const dispatch = useDispatch();

    const [formYetki, setFormYetki] = useState(
        {
            getKayit: hasRole("tanimlar|tesviktanimi|getKayit"),    
            listele: hasRole("tanimlar|tesviktanimi|listele"),  
            ekle: hasRole("tanimlar|tesviktanimi|ekle"),  
            degistir: hasRole("tanimlar|tesviktanimi|degistir"),  
            sil: hasRole("tanimlar|tesviktanimi|sil"),   
        });

    const listeBasligi = "Teşvik Rapor Fark";
    const [store, setStore] = useState(null);
    const [tesvikKanunuData, setTesvikKanunuData] = useState({ popupState: false, data: [] });

    let dataGrid = null;

    useEffect(() => {
        setStore(getStore());
    }, [])


    const getStore = () => {

        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) { 
                const request = new Request("/tesvikkanunu/getKayitList", "GET");

                return request.run()
                    .then(response => {
                        if (response.data) {
                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }
    const yenile = () => {

        setStore(getStore());
    }

    function onToolbarPreparingDetay(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            //template: 'totalGroupCount'
        }, {
            location: 'after',
            widget: 'dxButton',
            visible: (e) => { return  formYetki.ekle },
            options: {
                icon: 'add',
                onClick: () => {
                    addDetay(null);
                }
            }
        });
    }

    function hideTesvikKanunuDataPopup() {
        setTesvikKanunuData({ popupState: false, data: {} })
        yenile();
    }
    

    function addDetay(data) {
        setTesvikKanunuData({ popupState: true, data: null })
    }
    function editDetay(data) {
        setTesvikKanunuData({ popupState: true, data: data })
    }
 
    return (
        <div >
            <h2 className={'dx-icon-product'} >{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>

                </div>
            </div>
            <DataGrid
                className="tesvikKanunuGrid"
                ref={ref => dataGrid = ref}
                width="100%"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                columnAutoWidth={false}
                onToolbarPreparing={onToolbarPreparingDetay}
            //selection={{ mode: 'single', deferred: true }} 
            >
                <FilterRow visible={true} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />

                <Column type="buttons" caption={'İşlem'}
                    buttons={[  
                        {
                            hint: 'Düzenle', icon: 'edit', 
                            visible: () => { return formYetki.degistir },		
                            onClick: (e) => { editDetay(e.row.data); }
                        } 
                    ]}
                />
                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} />
                <Column dataField={'kanunNumarasi'} width={90} caption={'Kanun No'} dataType="int" visible={true} />
                <Column dataField={'adi'} width={90} caption={'Adı'} dataType="string" visible={true} />
                
            </DataGrid>

            <Popup
                visible={tesvikKanunuData.popupState}
                onHiding={hideTesvikKanunuDataPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                //showTitle={true}
                title = "   Teşvik Kanunu Detay Bilgi"
                width={450}
                height={250}
            >
                <div>
                    {tesvikKanunuData.popupState ? <TesvikKanunuDetail data={tesvikKanunuData.data} hide={hideTesvikKanunuDataPopup} /> : null}
                    <Button
                        width={1000}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideTesvikKanunuDataPopup}
                    />
                </div>
            </Popup>

        </div>
    )
}

export default TesvikKanunu;
